module.exports = __webpack_public_path__ + "static/media/bpmeasurex-2.f07a3775.jpg";